import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu"
}
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "menu-actions" }
const _hoisted_4 = { class: "dark-mode action-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileNavMenuItem = _resolveComponent("MobileNavMenuItem")!
  const _component_Light = _resolveComponent("Light")!
  const _component_Dark = _resolveComponent("Dark")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Vector = _resolveComponent("Vector")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (navItem) => {
            return (_openBlock(), _createBlock(_component_MobileNavMenuItem, {
              key: navItem.value,
              label: navItem.name,
              to: { name: navItem.value },
              active: _ctx.$route.name == navItem.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, null, 8, ["label", "to", "active"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isDarkMode)
              ? (_openBlock(), _createBlock(_component_Light, {
                  key: 0,
                  color: 'rgb(255 255 255 / 60%)'
                }))
              : (_openBlock(), _createBlock(_component_Dark, {
                  key: 1,
                  color: 'rgb(255 255 255 / 60%)'
                }))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["action-item language-dropdown", { open: _ctx.dropdownOpened }])
          }, [
            _createVNode(_component_Dropdown, {
              position: "right-top",
              modelValue: _ctx.currentLanguage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentLanguage) = $event)),
              open: _ctx.dropdownOpened,
              "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dropdownOpened) = $event)),
              options: _ctx.languageOptions
            }, {
              default: _withCtx(() => [
                (_ctx.selectedLanguageIcon)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selectedLanguageIcon), { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "open", "options"])
          ], 2)
        ]),
        _createElementVNode("div", {
          class: "close",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_Vector)
        ])
      ]))
    : _createCommentVNode("", true)
}